import PropTypes from "prop-types";
// form
import { useFormContext, Controller } from "react-hook-form";

// @mui
// import { TextField } from "@mui/material";

// ----------------------------------------------------------------------

RHFSelectField.propTypes = {
  name: PropTypes.string,
  label: PropTypes.string,
  type: PropTypes.string,
  classes: PropTypes.string,
};

RHFSelectField.defaultProps = {
  outerClasses:
    "flex flex-col sm:flex-row items-center child:w-full child:first:!mb-0 child:mr-4 mb-4",
};

export default function RHFSelectField({
  name,
  label,
  type,
  classes,
  outerClasses,
  children,
  ...other
}) {
  const { control } = useFormContext();

  return (
    <Controller
      name={name}
      control={control}
      render={({ field, fieldState: { error, isDirty } }) => (
        <>
          <div className={outerClasses}>
            <label
              htmlFor="select"
              className="capitalize text-left block pb-4 font-[500]  ">
              {label}
            </label>
            <select
              id="select"
              {...field}
              fullWidth
              type={type}
              value={
                typeof field.value === "number" && field.value === 0
                  ? ""
                  : field.value
              }
              error={Boolean(error)}
              className={` ${error && "invalid "} ${
                isDirty &&
                !error &&
                "outline-green-400 outline-2 border-transparent"
              } rounded  w-full p-2 px-4 focus:outline-blue-400 focus:bg-white focus:border-transparent   focus:shadow-blue-400 border bg-slate-50 outline-none ${classes}`}
              {...other}>
              {children}
            </select>
          </div>
          <p className="text-red-400 mt-2">{error?.message}</p>
        </>
      )}
    />
  );
}
